import { Context, createContext, useContext } from 'react';
import { FirestoreBuildingView } from '../lib/model/kantoordag/buildingsStreamingApi.ts';

let BuildingContext : Context<FirestoreBuildingView>;
export const createBuildingContext = (building: FirestoreBuildingView) => {
    BuildingContext = createContext<FirestoreBuildingView>(building);
    return BuildingContext;
}
export const useBuildingContext = () => useContext(BuildingContext);